import { Injectable } from '@angular/core';
import { TableState } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class TableStateService {

  private allowedStateFeatures = ["sortField", "sortOrder", "multiSortMeta", "first", "rows"];

  constructor() { }

  onStateSave = (tableState: TableState, stateKey) => {
    const allowedTableState = Object.keys(tableState)
      .filter(key => this.allowedStateFeatures.includes(key))
      .reduce((obj, key) => {
        switch (key) {
          case "first":
            obj[key] = 0;
            break;
          default:
            obj[key] = tableState[key];
        }
        return obj;
      }, {});

    localStorage.setItem(stateKey, JSON.stringify(allowedTableState))
  }
}
